module.exports = __webpack_public_path__ + "static/svcf-46167d147e869404b0f2ad985656415a.png";